module.exports = __webpack_public_path__ + "static/media/csvicon.d9c37a8e.svg";